import type { ExtractedTextSegment } from '../../extract-paragraphs/shared/types';
import type { DiffSegment } from '../../slate-api/transforms/layered-diffs/types';

/**
 * Converts a paragraph's `ExtractedTextSegment[]` (the slate-side view that
 * already encodes the user's pre-existing tracked redlines) into the
 * `DiffSegment[]` shape `createVisualDiff` expects. The visible text
 * (`segments` joined while filtering `remove`) is identical to
 * `paragraphInfo.text`, so this preserves diff alignment against the LLM's
 * `finalText` while letting `createVisualDiff` attribute characters as
 * `oldInsert` / `oldDelete` where the user had prior edits.
 *
 * The `id` field on insert/delete segments is required by the type but is
 * not read by the visual-diff pipeline, so a stable index-based id is enough.
 */
export function extractedSegmentsToDiffSegments(segments: ExtractedTextSegment[]): DiffSegment[] {
  return segments.map((segment, index) => {
    if (segment.edit === 'insert')
      return { id: `existing-${index}`, op: 'insert', text: segment.text };
    if (segment.edit === 'remove')
      return { id: `existing-${index}`, op: 'delete', text: segment.text };
    return { op: 'equal', text: segment.text };
  });
}
